import { normalize } from 'normalizr';
import { camelizeKeys, decamelizeKeys } from 'humps';
import { getJSON } from 'redux-api-middleware';
import { API_FAILURE } from './index';
import { Schemas } from './schemas';

export const addMeta = (type, meta) => {
  return { type, meta };
}

export const tranformEmptyPayload = (type, meta = {}) => {
  return {
    type,
    meta,
    payload: (_action, _state, _res) => {},
  }
}

export const tranformSuccessPayload = (type, meta = {}) => {
  return {
    type,
    meta,
    payload: (action, state, res) =>
      getJSON(res).then(camelizeKeys),
  }
}

export const tranformSuccessPayloadWithHeaders = (type, meta = {}) => {
  return {
    type,
    meta,
    payload: (action, state, res) =>
      getJSON(res).then(camelizeKeys).then(json =>({ data: json, headers: res.headers })),
  }
}

export const transformResultPayload = (res) => camelizeKeys(res);

export const tranformChartPayload = (type, meta = {}) => {
  return {
    type,
    meta,
    payload: (action, state, res) =>
      getJSON(res).then(json => camelizeKeys(json, (key, convert) => /(-)+/.test(key) ? key : convert(key)))
  }
}

export const transformBodyParams = (obj) => JSON.stringify(decamelizeKeys(obj))

export const normalizeSuccessPayload = (type, schemaType, meta = {}) => {
  return {
    type,
    meta,
    payload: (action, state, res) =>
      getJSON(res).then(camelizeKeys).then(json => normalize(json, Schemas[schemaType] || {})),
  }
}

export const transformErrorPayload = (meta = {}) => {
  return {
    type: API_FAILURE,
    meta: { ...meta, type: meta.originalType }, // сохраняем тип оригинального REQUEST
    payload: (action, state, res) => {
      return getJSON(res).then(error => ({ error }));
    }
  }
}
